import template from './sw-cms-el-acris-faq-single.html.twig';
import './sw-cms-el-acris-faq-single.scss';

const { Component, Mixin } = Shopware;

Component.register('sw-cms-el-acris-faq-single', {
    template,

    mixins: [
        Mixin.getByName('cms-element')
    ],

    computed: {
        faqElements() {
            return this.element.config.faqs.value;
        }
    },

    created() {
        this.createdComponent();
    },

    methods: {
        createdComponent() {
            this.initElementConfig('acris-faq-single');
            this.initElementData('acris-faq-single');
        },
    }
});
